import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UserService} from '../../services/user.service';

@Injectable({
    providedIn: 'root'
})
export class LoginResolver implements Resolve<void> {

    constructor(private userService: UserService){}


    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void | Observable<void> | Promise<void> {
        this.userService.setUser(null);
    }

}
